import { BehaviorSubject } from 'rxjs';
import { IMenu } from './models/core/menu';
import { environment } from '@env/environment';

export const menu$ = new BehaviorSubject<IMenu[]>([
    {
      route: "dashboard",
      name: "Dashboard",
      type: "link",
      icon: "dashboard",
      auth: true,
      roles: ['Admin','LeadBasedPaint'],
      visible: true
    },
    {
      route: "atp",
      name: "ATP",
      type: "sub",
      icon: "school",
      auth: true,
      roles: ['Admin','LeadBasedPaint'],
      visible: true,
      children: [
        {
          route: "/management",
          name: "ATP Management",
          type: "link",
        },
        {
          route: "/students",
          name: "ATP Students",
          type: "link",
        },
        {
          route: "/courses",
          name: "ATP Courses",
          type: "link",
        },
        {
          route: "/applications",
          name: "ATP Applications",
          type: "link",
        }
      ]
    },
    {
      route: "firm",
      name: "Firm",
      type: "sub",
      icon: "business",
      auth: true,
      roles: ['Admin','LeadBasedPaint'],
      visible: true,
      children: [
        {
          route: "/management",
          name: "Firm Management",
          type: "link",
        },
        {
          route: "/applications",
          name: "Firm Application",
          type: "link"
        },
      ]
    },
    {
      route: "individual",
      name: "Individual",
      type: "sub",
      icon: "recent_actors",
      auth: true,
      roles: ['Admin','LeadBasedPaint'],
      visible: true,
      children: [
        {
          route: "/management",
          name: "Individual Management",
          type: "link",
        },
        {
          route: "/applications",
          name: "Individual Application",
          type: "link"
        },
      ]
    },
    {
      route: "complaint",
      name: "Compliance",
      type: "sub",
      icon: "create_new_folder",
      auth: true,
      roles: ['Admin','LeadBasedPaint'],
      visible: true,
      children: [
        {
          route: "/list",
          name: "View Records",
          type: "link",
        },
      ]
    },
    {
      route: "payments",
      name: "Payments",
      type: "link",
      icon: "attach_money",
      auth: true,
      roles: ['Admin','LeadBasedPaint'], //If you want to restrict a route to certain roles include them in a list
      visible: true
    },
    {
      route: "reports",
      name: "Reports",
      type: "link",
      icon: "bar_chart",
      roles: ['Admin','LeadBasedPaint'],
      visible: true
    },
    {
      route: "calltracker",
      name: "Call Tracker",
      type: "sub",
      icon: "phone_in_talk",
      auth: true,
      roles: ['Admin','CallTracker'],
      visible: environment.callTrackerEnabled,
      children: [
        {
          route: "/inquiries",
          name: "Inquiries",
          type: "link",
        },
        {
          route: "/metrics",
          name: "Metrics",
          type: "link"
        },
      ]
    },
    {
      route: "admin",
      name: "Admin",
      type: "sub",
      icon: "admin_panel_settings",
      auth: true,
      roles: ['Admin'], //If you want to restrict a route to certain roles include them in a list
      visible: true,
      children: [
        {
          route: "/user-management",
          name: "User Management",
          type: "link",
        },
        {
          route: "/admin-functions",
          name: "Admin Functions",
          type: "link",
        },
      ]
    },
  ]);
